var cov_1ye8em26pu = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Month.tsx",
      hash = "d002bc056d3a2068167d25d3c3628ad1c8f21288",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Month.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 18
        },
        end: {
          line: 10,
          column: 39
        }
      },
      "1": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 16
        }
      },
      "2": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 61
        }
      },
      "3": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 62
        }
      },
      "4": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 58
        }
      },
      "5": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 56
        }
      },
      "6": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 69
        }
      },
      "7": {
        start: {
          line: 29,
          column: 25
        },
        end: {
          line: 29,
          column: 35
        }
      },
      "8": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 63
        }
      },
      "9": {
        start: {
          line: 34,
          column: 34
        },
        end: {
          line: 34,
          column: 44
        }
      },
      "10": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 100
        }
      },
      "11": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 35
        }
      },
      "12": {
        start: {
          line: 43,
          column: 48
        },
        end: {
          line: 43,
          column: 58
        }
      },
      "13": {
        start: {
          line: 44,
          column: 15
        },
        end: {
          line: 44,
          column: 42
        }
      },
      "14": {
        start: {
          line: 45,
          column: 24
        },
        end: {
          line: 45,
          column: 51
        }
      },
      "15": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 68
        }
      },
      "16": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 63
        }
      },
      "17": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 83
        }
      },
      "18": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 41
        }
      },
      "19": {
        start: {
          line: 49,
          column: 22
        },
        end: {
          line: 49,
          column: 41
        }
      },
      "20": {
        start: {
          line: 53,
          column: 66
        },
        end: {
          line: 53,
          column: 76
        }
      },
      "21": {
        start: {
          line: 55,
          column: 21
        },
        end: {
          line: 55,
          column: 84
        }
      },
      "22": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 58,
          column: 5
        }
      },
      "23": {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 57,
          column: 82
        }
      },
      "24": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 62,
          column: 5
        }
      },
      "25": {
        start: {
          line: 61,
          column: 6
        },
        end: {
          line: 61,
          column: 33
        }
      },
      "26": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 72,
          column: 5
        }
      },
      "27": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 71,
          column: 7
        }
      },
      "28": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 25
        }
      },
      "29": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 21
        }
      },
      "30": {
        start: {
          line: 77,
          column: 31
        },
        end: {
          line: 77,
          column: 41
        }
      },
      "31": {
        start: {
          line: 78,
          column: 15
        },
        end: {
          line: 78,
          column: 57
        }
      },
      "32": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 115
        }
      },
      "33": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 64
        }
      },
      "34": {
        start: {
          line: 81,
          column: 23
        },
        end: {
          line: 81,
          column: 48
        }
      },
      "35": {
        start: {
          line: 83,
          column: 22
        },
        end: {
          line: 86,
          column: 5
        }
      },
      "36": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 91,
          column: 5
        }
      },
      "37": {
        start: {
          line: 95,
          column: 24
        },
        end: {
          line: 95,
          column: 34
        }
      },
      "38": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 111,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        },
        loc: {
          start: {
            line: 17,
            column: 39
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 15
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 28
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 33
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 33
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 20
          },
          end: {
            line: 40,
            column: 3
          }
        },
        line: 38
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        loc: {
          start: {
            line: 42,
            column: 34
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 42
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 52,
            column: 29
          },
          end: {
            line: 74,
            column: 3
          }
        },
        line: 52
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 76,
            column: 3
          }
        },
        loc: {
          start: {
            line: 76,
            column: 36
          },
          end: {
            line: 92,
            column: 3
          }
        },
        line: 76
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 94,
            column: 2
          },
          end: {
            line: 94,
            column: 3
          }
        },
        loc: {
          start: {
            line: 94,
            column: 11
          },
          end: {
            line: 112,
            column: 3
          }
        },
        line: 94
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 49,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 49,
            column: 41
          }
        }, {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 49,
            column: 41
          }
        }],
        line: 49
      },
      "1": {
        loc: {
          start: {
            line: 55,
            column: 21
          },
          end: {
            line: 55,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 21
          },
          end: {
            line: 55,
            column: 24
          }
        }, {
          start: {
            line: 55,
            column: 28
          },
          end: {
            line: 55,
            column: 84
          }
        }],
        line: 55
      },
      "2": {
        loc: {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 58,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 58,
            column: 5
          }
        }, {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 58,
            column: 5
          }
        }],
        line: 56
      },
      "3": {
        loc: {
          start: {
            line: 57,
            column: 19
          },
          end: {
            line: 57,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 57,
            column: 19
          },
          end: {
            line: 57,
            column: 22
          }
        }, {
          start: {
            line: 57,
            column: 26
          },
          end: {
            line: 57,
            column: 82
          }
        }],
        line: 57
      },
      "4": {
        loc: {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        }, {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        }],
        line: 60
      },
      "5": {
        loc: {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 19
          }
        }, {
          start: {
            line: 60,
            column: 23
          },
          end: {
            line: 60,
            column: 39
          }
        }, {
          start: {
            line: 60,
            column: 43
          },
          end: {
            line: 60,
            column: 73
          }
        }],
        line: 60
      },
      "6": {
        loc: {
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        }, {
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 72,
            column: 5
          }
        }],
        line: 64
      },
      "7": {
        loc: {
          start: {
            line: 64,
            column: 8
          },
          end: {
            line: 64,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 8
          },
          end: {
            line: 64,
            column: 19
          }
        }, {
          start: {
            line: 64,
            column: 23
          },
          end: {
            line: 64,
            column: 34
          }
        }, {
          start: {
            line: 64,
            column: 38
          },
          end: {
            line: 64,
            column: 56
          }
        }],
        line: 64
      },
      "8": {
        loc: {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        }, {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        }],
        line: 65
      },
      "9": {
        loc: {
          start: {
            line: 66,
            column: 8
          },
          end: {
            line: 68,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 8
          },
          end: {
            line: 66,
            column: 23
          }
        }, {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 20
          }
        }, {
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 68,
            column: 92
          }
        }],
        line: 66
      },
      "10": {
        loc: {
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 84,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 84,
            column: 55
          }
        }, {
          start: {
            line: 84,
            column: 59
          },
          end: {
            line: 84,
            column: 67
          }
        }],
        line: 84
      },
      "11": {
        loc: {
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 85,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 85,
            column: 16
          }
        }, {
          start: {
            line: 85,
            column: 20
          },
          end: {
            line: 85,
            column: 30
          }
        }],
        line: 85
      },
      "12": {
        loc: {
          start: {
            line: 88,
            column: 51
          },
          end: {
            line: 88,
            column: 111
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 88,
            column: 64
          },
          end: {
            line: 88,
            column: 73
          }
        }, {
          start: {
            line: 88,
            column: 76
          },
          end: {
            line: 88,
            column: 111
          }
        }],
        line: 88
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0],
      "9": [0, 0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Month.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { datepickerClass } from './styles';
import Icon from './Icon';
import utils from './utils';
import { getLocale } from '../locale';
import paramUtils from './paramUtils';
import { isArray, isNumber } from '../utils/is';
var MONTHBASE = (cov_1ye8em26pu.s[0]++, '2019-01-01 00:00:00');

var Month =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Month, _PureComponent);

  var _super = _createSuper2(Month);

  function Month(props) {
    var _this;

    _classCallCheck(this, Month);

    cov_1ye8em26pu.f[0]++;
    cov_1ye8em26pu.s[1]++;
    _this = _super.call(this, props);
    _this.handleNextYear = void 0;
    _this.handlePrevYear = void 0;
    cov_1ye8em26pu.s[2]++;
    _this.handleNextYear = _this.handleYearChange.bind(_assertThisInitialized(_this), 1);
    cov_1ye8em26pu.s[3]++;
    _this.handlePrevYear = _this.handleYearChange.bind(_assertThisInitialized(_this), -1);
    cov_1ye8em26pu.s[4]++;
    _this.handleYearClick = _this.handleYearClick.bind(_assertThisInitialized(_this));
    cov_1ye8em26pu.s[5]++;
    _this.handleDisabled = _this.handleDisabled.bind(_assertThisInitialized(_this));
    cov_1ye8em26pu.s[6]++;
    props.disabledRegister(_this.handleDisabled, 'month', props.index);
    return _this;
  }

  _createClass(Month, [{
    key: "getOptions",
    value: function getOptions() {
      cov_1ye8em26pu.f[1]++;

      var _ref = (cov_1ye8em26pu.s[7]++, this.props),
          timeZone = _ref.timeZone;

      cov_1ye8em26pu.s[8]++;
      return {
        timeZone: timeZone,
        weekStartsOn: getLocale('startOfWeek')
      };
    }
  }, {
    key: "handleYearChange",
    value: function handleYearChange(year) {
      cov_1ye8em26pu.f[2]++;

      var _ref2 = (cov_1ye8em26pu.s[9]++, this.props),
          current = _ref2.current,
          onChange = _ref2.onChange;

      cov_1ye8em26pu.s[10]++;
      onChange.apply(void 0, _toConsumableArray(paramUtils.yearHandleChangeParams(utils.addYears(current, year, this.getOptions()))));
    }
  }, {
    key: "handleYearClick",
    value: function handleYearClick() {
      cov_1ye8em26pu.f[3]++;
      cov_1ye8em26pu.s[11]++;
      this.props.onModeChange('year');
    }
  }, {
    key: "handleMonthClick",
    value: function handleMonthClick(month) {
      cov_1ye8em26pu.f[4]++;

      var _ref3 = (cov_1ye8em26pu.s[12]++, this.props),
          current = _ref3.current,
          onChange = _ref3.onChange,
          onModeChange = _ref3.onModeChange;

      var date = (cov_1ye8em26pu.s[13]++, new Date(current.getTime()));
      var isMonthType = (cov_1ye8em26pu.s[14]++, this.props.type === 'month');
      cov_1ye8em26pu.s[15]++;
      date = utils.changeDate(date, 'month', month, this.getOptions());
      cov_1ye8em26pu.s[16]++;
      date = utils.changeDate(date, 'date', 1, this.getOptions());
      cov_1ye8em26pu.s[17]++;
      onChange.apply(void 0, _toConsumableArray(paramUtils.monthHandleChangeParams(date, isMonthType, isMonthType)));
      cov_1ye8em26pu.s[18]++;

      if (!isMonthType) {
        cov_1ye8em26pu.b[0][0]++;
        cov_1ye8em26pu.s[19]++;
        onModeChange('day');
      } else {
        cov_1ye8em26pu.b[0][1]++;
      }
    }
  }, {
    key: "handleDisabled",
    value: function handleDisabled(date) {
      cov_1ye8em26pu.f[5]++;

      var _ref4 = (cov_1ye8em26pu.s[20]++, this.props),
          min = _ref4.min,
          disabled = _ref4.disabled,
          range = _ref4.range,
          type = _ref4.type,
          index = _ref4.index,
          rangeDate = _ref4.rangeDate,
          max = _ref4.max;

      var isDisabled = (cov_1ye8em26pu.s[21]++, (cov_1ye8em26pu.b[1][0]++, min) && (cov_1ye8em26pu.b[1][1]++, utils.compareMonth(min, date, 1, this.getOptions()) >= 0));
      cov_1ye8em26pu.s[22]++;

      if (!isDisabled) {
        cov_1ye8em26pu.b[2][0]++;
        cov_1ye8em26pu.s[23]++;
        isDisabled = (cov_1ye8em26pu.b[3][0]++, max) && (cov_1ye8em26pu.b[3][1]++, utils.compareMonth(date, max, 1, this.getOptions()) >= 0);
      } else {
        cov_1ye8em26pu.b[2][1]++;
      }

      cov_1ye8em26pu.s[24]++;

      if ((cov_1ye8em26pu.b[5][0]++, !isDisabled) && (cov_1ye8em26pu.b[5][1]++, type === 'month') && (cov_1ye8em26pu.b[5][2]++, typeof disabled === 'function')) {
        cov_1ye8em26pu.b[4][0]++;
        cov_1ye8em26pu.s[25]++;
        isDisabled = disabled(date);
      } else {
        cov_1ye8em26pu.b[4][1]++;
      }

      cov_1ye8em26pu.s[26]++;

      if ((cov_1ye8em26pu.b[7][0]++, !isDisabled) && (cov_1ye8em26pu.b[7][1]++, index === 1) && (cov_1ye8em26pu.b[7][2]++, isArray(rangeDate))) {
        cov_1ye8em26pu.b[6][0]++;
        cov_1ye8em26pu.s[27]++;

        if ((cov_1ye8em26pu.b[9][0]++, isNumber(range)) && (cov_1ye8em26pu.b[9][1]++, rangeDate[0]) && (cov_1ye8em26pu.b[9][2]++, utils.compareAsc(date, utils.addSeconds(rangeDate[0], range, this.getOptions())) > 0)) {
          cov_1ye8em26pu.b[8][0]++;
          cov_1ye8em26pu.s[28]++;
          isDisabled = true;
        } else {
          cov_1ye8em26pu.b[8][1]++;
        }
      } else {
        cov_1ye8em26pu.b[6][1]++;
      }

      cov_1ye8em26pu.s[29]++;
      return isDisabled;
    }
  }, {
    key: "renderMonth",
    value: function renderMonth(m, i) {
      cov_1ye8em26pu.f[6]++;

      var _ref5 = (cov_1ye8em26pu.s[30]++, this.props),
          value = _ref5.value,
          current = _ref5.current;

      var date = (cov_1ye8em26pu.s[31]++, utils.toDate(MONTHBASE, this.getOptions()));
      cov_1ye8em26pu.s[32]++;
      date = utils.changeDate(date, 'year', utils.getDateInfo(current, 'year', this.getOptions()), this.getOptions());
      cov_1ye8em26pu.s[33]++;
      date = utils.changeDate(date, 'month', i, this.getOptions());
      var isDisabled = (cov_1ye8em26pu.s[34]++, this.handleDisabled(date));
      var className = (cov_1ye8em26pu.s[35]++, datepickerClass((cov_1ye8em26pu.b[10][0]++, utils.isSameMonth(value, date, this.getOptions())) && (cov_1ye8em26pu.b[10][1]++, 'active'), (cov_1ye8em26pu.b[11][0]++, isDisabled) && (cov_1ye8em26pu.b[11][1]++, 'disabled')));
      cov_1ye8em26pu.s[36]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          key: i,
          className: className,
          onClick: isDisabled ? (cov_1ye8em26pu.b[12][0]++, undefined) : (cov_1ye8em26pu.b[12][1]++, this.handleMonthClick.bind(this, i)),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 88,
            columnNumber: 7
          }
        }, m)
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_1ye8em26pu.f[7]++;

      var _ref6 = (cov_1ye8em26pu.s[37]++, this.props),
          current = _ref6.current;

      cov_1ye8em26pu.s[38]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('month-picker'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 98,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('header'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 99,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement(Icon, {
          name: "AngleLeft",
          className: "left",
          onClick: this.handlePrevYear,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 100,
            columnNumber: 11
          }
        }),
        /*#__PURE__*/
        React.createElement("span", {
          onClick: this.handleYearClick.bind(this),
          className: datepickerClass('ym'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 102,
            columnNumber: 11
          }
        }, utils.getDateInfo(current, 'year', this.getOptions())),
        /*#__PURE__*/
        React.createElement(Icon, {
          name: "AngleRight",
          className: "right",
          onClick: this.handleNextYear,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 106,
            columnNumber: 11
          }
        })),
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('list'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 109,
            columnNumber: 9
          }
        }, getLocale('monthValues.short').map(this.renderMonth.bind(this))))
      );
    }
  }]);

  return Month;
}(PureComponent);

export default Month;